import React, { useState } from 'react'
import { Button } from 'antd'
import gql from 'graphql-tag'
import { useFormContext } from '@/state/main-form/reducer'
import { useFormLlmInterfacesQuery } from './__gen'
import { AiChatbot } from './ai-chatbot'
import style from './index.module.sass'

gql`
	query formLlmInterfaces($formId: ID!) {
		formLlmInterface_List(formId: $formId) {
			objects {
				id
				llmInterface {
					id
				}
			}
		}
	}
`

export const LlmInterfaceList = () => {
	const formContext = useFormContext()
	const { data, loading } = useFormLlmInterfacesQuery({
		variables: {
			formId: formContext.form.id,
		},
	})

	const [show, setShow] = useState(false)

	const interfaces = data?.formLlmInterface_List?.objects || []

	if (interfaces.length === 0) {
		return null
	}

	return (
		<>
			{show ?
				<AiChatbot onClose={() => setShow(false)} formLlmInterface={interfaces[0]} />
			:	<Button onClick={() => setShow(!show)} className={style.aiSupportButton} type="primary" size="middle">
					AI Support
				</Button>
			}
		</>
	)
}
